<template>
<master-layout pageTitle="Live Chat Settings">
  <div>
    <div v-if="!editShortcutModal && !editMode" class="tabs-toolbar">
      <div class="tabs-row">
        <button type="button" :class="['tab-item', { active: activeTab === 'office-hours' }]" @click="changeTab('office-hours')">Office hours</button>
        <button type="button" :class="['tab-item', { active: activeTab === 'away-message' }]" @click="changeTab('away-message')">Away message</button>
        <button type="button" :class="['tab-item', { active: activeTab === 'message-shortcuts' }]" @click="changeTab('message-shortcuts')">Message shortcuts</button>
        <button type="button" :class="['tab-item', { active: activeTab === 'unique-welcome-message' }]" @click="changeTab('unique-welcome-message')">Unique link welcome message</button>
        <button type="button" :class="['tab-item', { active: activeTab === 'support-message' }]" @click="changeTab('support-message')">Talk to support message</button>
      </div>
    </div>
    
    <div v-if="activeTab === 'office-hours'">
      <div v-if="!editMode">
        <div v-if="allTimings.length > 0" class="gridMargin flex-end">
          <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add new" @click="addNewOfficeHours"></VButton>
        </div>
        <div v-if="allTimings.length > 0" class="gridMargin">
          <div class="model-sections">
            <div class="table-header">
              <div class="office-row">
                <div class="cell-name"><span class="vtext-subtitle">Name</span></div>
                <div class="cell-hours"><span class="vtext-subtitle">Opening hours</span></div>
                <div class="cell-actions text-right hide-mobile"><span class="vtext-subtitle">Actions</span></div>
              </div>
            </div>
            <div v-for="(thisTiming, tIndex) in allTimings" :key="thisTiming.id" class="office-row sectionPadding cust-brdr">
              <div class="cell-name"><p class="vtext-body">{{ thisTiming.name }}</p></div>
              <div class="cell-hours">
                <div class="flex-start gap20P">
                  <div class="daysRow">
                    <span class="displayDay vtext-body" v-for="thisDay in daysArr" :key="thisDay.value" :class="thisTiming.validdays.indexOf(thisDay.value) > -1 ? 'selected' : ''">
                      {{ thisDay.day.substring(0, 1) }}
                    </span>
                  </div>
                  <div>
                    <span class="vtext-body">{{ formatTime(thisTiming.validfrom) + '-' + formatTime(thisTiming.validtill) }}</span>
                  </div>
                  <div v-if="formatTime(thisTiming.validfrom) === '12:00 AM' && formatTime(thisTiming.validtill) === '11:59 PM'">
                    <span class="hour-chip">24 Hours</span>
                  </div>
                </div>
              </div>
              <div class="cell-actions text-right hide-mobile">
                <div class="actionContainer">
                  <VIcon name="edit-line" @click="editOfficeHours(tIndex)" class="actionIcons cursorPointer"></VIcon>
                  <VIcon name="delete-line" connotation="alert" class="trashIcon actionIcons cursorPointer" @click="() => {deleteTimingMode = true; dummyTiming = JSON.parse(JSON.stringify(thisTiming));}"></VIcon>
                </div>
              </div>
              <div class="cell-actions show-mobile">
                <ActionPopOver :style="{'--width': '215px'}">
                  <div class="listContainer">
                    <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Edit" icon="edit-line" @click="editOfficeHours(tIndex)"></VButton>
                    <VButton class="vvd-btn-danger-outline vvd-btn-block" connotation="announcement" appearance="outlined" label="Delete" icon="delete-line" @click="() => {deleteTimingMode = true; dummyTiming = JSON.parse(JSON.stringify(thisTiming));}"></VButton>
                  </div>
                </ActionPopOver>
              </div>
            </div>
          </div>
        </div>
        <div v-if="allTimings.length == 0 && dataLoaded" class="text-center emptyContainer">
          <div>
            <img src="./../../resources/images/office_hours_updated.svg" class="segmentImg" alt="empty_hours" />
            <h2 class="vtext-hero-title vpb-5">Welcome to Office hours</h2>
            <p class="vtext-hero-subtitle vpb-10">Set your opening hours for your business.</p>
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add new" icon="arrow-right-line" @click="addNewOfficeHours"></VButton>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- edit Mode -->
        <div class="chat-toolbar">
          <div class="toolbar-start">
            <VIcon name="arrow-left-line" :size="-4" @click="cancelOfficeHoursEdit" class="cursorPointer"></VIcon>
            <h2 class="vtext-page-title--regular vml-20">{{ officeHoursIndexToEdit > -1 ? 'Edit' : 'Add new'}} hours</h2>
          </div>
          <div>
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Save" :disabled="disableOfficeBttn" @click="saveTimings"></VButton>
          </div>
        </div>
        <div class="vgrid--no-padding gridMargin">
          <div class="vcol vcol--no-padding vcol-xl-8 vcol-lg-8 vcol-sm-12 vcol-xs-12">
            <div class="model-sections sectionPadding">
              <div class="optionsContainer cust-brdr">
                <p class="vtext-body vpb-10">Name (Max 30 characters).</p>
                <div class="counter-wrapper">
                  <VTextField v-model="officeHours.name" :maxlength="30" placeholder="Enter name" aria-label="name" appearance="ghost" class="vivid-input"></VTextField>
                  <div class="custom-counter">
                      {{ (officeHours.name || '').length }}/30
                  </div>
                </div>
              </div>
              <div class="optionsContainer cust-brdr">
                <p class="vtext-body vpb-10">Open on</p>
                <div class="flex-between">
                  <div class="daysRow cursorPointer">
                    <span class="day vtext-body" @click="officeHours.validdays.indexOf(thisDay.value) > -1 ? officeHours.validdays.splice(officeHours.validdays.indexOf(thisDay.value), 1) : officeHours.validdays.push(thisDay.value)" v-for="thisDay in daysArr" :key="thisDay.value" :class="officeHours.validdays.indexOf(thisDay.value) > -1 ? 'selected' : ''">
                      {{ thisDay.day }}
                    </span>
                  </div>
                  <div>
                    <VSwitch :checked="officeHours.allDaysEnabled" @change="(e) => { officeHours.allDaysEnabled = e.target.checked; selectAllDays(); }" connotation="cta" label="All week"></VSwitch>
                  </div>
                </div>
              </div>
              <div class="flex-between">
                <div class="flex-between width100P">
                  <div class="flex100P">
                    <p class="vtext-subtitle vpb-10">Open at</p>
                      <input type="time" :name="'validfrom'" :disabled="officeHours.is24Hrs" v-model="officeHours.validfrom" class="width100P slctTime" />
                  </div>
                  <div class="flex100P">
                    <p class="vtext-subtitle vpb-10">Close at</p>
                      <input type="time" :name="'validtill'" :disabled="officeHours.is24Hrs" v-model="officeHours.validtill" class="width100P slctTime" />
                  </div>
                </div>
                <div>
                  <VSwitch :checked="officeHours.is24Hrs" @change="on24HrsToggle" connotation="cta" label="24 Hours"></VSwitch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 'away-message'">
      <div class="model-sections gridMargin width60P">
        <div class="previewHeader">
          <h2 class="vtext-card-title--light vpb-10">Away message</h2>
          <p class="vtext-subtitle">This message will be sent to customers who are willing to talk to live chat agent and no agent is available.</p>
        </div>
        <div class="sectionPadding">
          <div class="marginBottom">
            <my-input
              aria-label="awayMessage"
              textarea
              id="awayMessage"
              :rows="4"
              name="awayMessage"
              placeholder="Enter away message" 
              :value="awayMessage"
              @onInput="(prop) => awayMessage = prop"
              :maxlength="960"
              lengthCounter
              class="templateInput"
            />
          </div>
          <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" :label="busyAway ? 'Saving...' : 'Save'" :disabled="busyAway || !awayMessage?.length" @click="updateAwayMessage"></VButton>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 'message-shortcuts'">
      <div v-if="!editShortcutModal">
        <div v-if="allShortcuts.length > 0" class="flexBetween gridMargin">
          <SearchBar v-model="shortcutFilter" placeholder="Search shortcuts" :rightIcon="true" backgroundColor="var(--white)" class="search-input-shortcuts" />
          <div class="hide-mobile">
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add New" @click="() => {editShortcutModal = true; dummyShortcut = JSON.parse(JSON.stringify(newShortcut));}"></VButton>
          </div>
          <div class="show-mobile">
            <ActionPopOver :style="{'--width': '177px'}">
              <div class="listContainer">
                <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Add New" @click="() => {editShortcutModal = true; dummyShortcut = JSON.parse(JSON.stringify(newShortcut));}"></VButton>
              </div>
            </ActionPopOver>
          </div>
        </div>
        <div v-if="shortcutsToShow.length > 0" class="gridMargin">
          <div class="model-sections">
            <div class="shortcut-table-header">
              <div class="shortcut-row">
                <div class="shortcut-cell cell-shortcut"><span class="vtext-subtitle">Shortcut</span></div>
                <div class="shortcut-cell cell-message"><span class="vtext-subtitle">Message</span></div>
                <div class="shortcut-cell cell-shortcut-actions text-right"><span class="vtext-subtitle">Actions</span></div>
              </div>
            </div>
            <div v-for="shortcut in shortcutsToShow" :key="shortcut.id" class="shortcut-row cust-brdr sectionPadding">
              <div class="shortcut-cell cell-shortcut"><span class="vtext-body">/{{ shortcut.name }}</span></div>
              <div class="shortcut-cell cell-message"><span class="vtext-body">{{ shortcut.response }}</span></div>
              <div class="shortcut-cell cell-shortcut-actions text-right hide-mobile">
                <div class="actionContainer">
                  <VIcon name="edit-line" class="actionIcons cursorPointer" @click="() => {editShortcutModal = true; dummyShortcut = JSON.parse(JSON.stringify(shortcut));}"></VIcon>
                  <VIcon name="delete-line" connotation="alert" class="trashIcon actionIcons cursorPointer" @click="() => {deleteShortcutMode = true; dummyShortcut = JSON.parse(JSON.stringify(shortcut));}"></VIcon>
                </div>
              </div>
              <div class="shortcut-cell cell-shortcut-actions show-mobile">
                <ActionPopOver :style="{'--width': '215px'}">
                  <div class="listContainer">
                    <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Edit" icon="edit-line" @click="() => {editShortcutModal = true; dummyShortcut = JSON.parse(JSON.stringify(shortcut));}"></VButton>
                    <VButton class="vvd-btn-danger-outline vvd-btn-block" connotation="announcement" appearance="outlined" label="Delete" icon="delete-line" @click="() => {deleteShortcutMode = true; dummyShortcut = JSON.parse(JSON.stringify(shortcut));}"></VButton>
                  </div>
                </ActionPopOver>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="shortcutFilter && shortcutFilter.length && shortcutsToShow.length === 0">
          <img src="../../resources/images/shortcuts.svg" class="segmentImg" alt="empty_shortcuts" />
          <h5> No shortcuts matching this filter! 😟 <span class="hyperlink_cust cursorPointer" @click="() => (shortcutFilter = undefined)">Clear filter</span> </h5>
        </div>
        <div v-if="allShortcuts.length == 0 && dataLoaded" class="text-center emptyContainer">
          <div>
            <img src="./../../resources/images/shortcuts.svg" class="segmentImg" alt="empty_shortcuts" />
            <h2 class="vtext-hero-title vpb-10">Welcome to Message Shortcuts</h2>
            <p class="vtext-hero-subtitle vpb-10">Create message shortcuts</p>
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add Shortcut" icon="arrow-right-line" @click="() => {editShortcutModal = true; dummyShortcut = JSON.parse(JSON.stringify(newShortcut));}"></VButton>
          </div>
        </div>
      </div>
      <div v-if="editShortcutModal">
        <div class="chat-toolbar">
          <div class="toolbar-start">
            <VIcon name="arrow-left-line" :size="-4" class="cursorPointer" @click="() => {editShortcutModal = false; dummyShortcut = JSON.parse(JSON.stringify(newShortcut));}"></VIcon>
            <h2 class="vtext-page-title--regular vml-20">{{ pageTitle }}</h2>
          </div>
          <div class="toolbar-end">
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" :label="dummyShortcut.id ? 'Update' : 'Save'" :disabled="busyShortcut" @click="updateShortcut"></VButton>
          </div>
        </div>
        <div class="vgrid--no-padding gridMargin">
          <div class="vrow">
            <div class="vcol vcol--no-padding vcol-xl-8 vcol-lg-8 vcol-md-8 vcol-sm-12 vcol-xs-12 model-sections">
              <div class="sectionPadding">
                <div class="marginBottom">
                  <p class="vtext-subtitle vpb-10">Shortcut (Max 60 characters)</p>
                  <div class="pre_text_full">
                    <span class="pre_text">&frasl;</span>
                    <VTextField v-model="dummyShortcut.name" :maxlength="60" placeholder="support" aria-label="name" appearance="ghost" class="vivid-input shortcut-name-input"></VTextField>
                  </div>
                </div>
                <div>
                  <p class="vtext-subtitle vpb-10">Message</p>
                  <my-input
                    aria-label="message"
                    textarea
                    id="editShortcutResponse"
                    :rows="4"
                    name="editShortcutResponse"
                    placeholder="Add shortcut message"
                    :value="dummyShortcut.response"
                    @onInput="(prop) => dummyShortcut.response = prop"
                    :maxlength="960"
                    class="templateInput"
                    lengthCounter
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 'unique-welcome-message'" class="model-sections width60P gridMargin">
      <div class="previewHeader">
        <h2 class="vtext-card-title--light vpb-10">Unique link welcome message</h2>
        <p class="vtext-subtitle">When users come to the business's channel from the agent's unique links, they will be greeted with the welcome message below and then assigned to the respective agent.</p>
      </div>
      <div class="sectionPadding">
        <div class="info-box marginBottom">
          <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
          <p class="vtext-body"> This can be used to greet the user, and also display your policy (eg: privacy policy and/or terms and conditions) that you need to display to your customers before they interact with your Business page. </p>
        </div>
        <div class="marginBottom">
          <my-input
            aria-label="message"
            textarea
            id="welcomeMessage"
            :rows="4"
            name="welcomeMessage"
            placeholder="Add welcome message" 
            :value="agentMessage"
            @onInput="(prop) => agentMessage = prop"
            :maxlength="960"
            class="templateInput"
            lengthCounter
          />
        </div>
        <div class="marginBottom">
          <p class="vtext-body vpb-10">Optional tags for message</p>
          <span class="tag-title">&lt;username&gt;</span>
          <span class="tag-title">&lt;agentname&gt;</span>
        </div>
        <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" :label="busyAgent ? 'Saving...' : 'Save'" :disabled="busyAgent" @click="updateAgentMessage"></VButton>
      </div>
    </div>

    <div v-if="activeTab === 'support-message'" class="model-sections width60P gridMargin">
      <div class="previewHeader">
        <h2 class="vtext-card-title--light vpb-10">Talk to support message</h2>
        <p class="vtext-subtitle">The following message will be sent to a user when they ask for manual support by clicking the "Talk to support" button.</p>
      </div>
      <div class="sectionPadding">
        <div class="marginBottom">
          <my-input
            textarea
            emoji
            id="agent-message"
            :rows="4"
            name="agent-message"
            :value="talkToSupportMessage"
            @onInput="(prop) => talkToSupportMessage = prop"
            :maxlength="960"
            class="templateInput"
            lengthCounter
            :iconStyle="{ bottom: '-4px'}"
          />
        </div>  
        <div class="marginBottom">
          <p class="vtext-body vpb-10">Optional tags for message</p>
          <span class="tag-title">&lt;username&gt;</span>
        </div>
        <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" :label="busySupport ? 'Saving...' : 'Save'" :disabled="busySupport || !talkToSupportMessage?.length" @click="updateSupportMessage"></VButton>
      </div>
    </div>
  </div>
  <!-- Delete Timing Confirmation -->
  <VDialog :open="deleteTimingMode" headline="Are you sure?" modal @close="() => { deleteTimingMode = false; dummyTiming = JSON.parse(JSON.stringify(newTiming)); }">
    <template #body>
      <p class="vtext-body">You want to remove this timing?</p>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => { dummyTiming = JSON.parse(JSON.stringify(newTiming)); deleteTimingMode = false; }"></VButton>
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="confirmRemoveTiming()"></VButton>
    </template>
  </VDialog>

  <!-- Delete Shortcut Confirmation -->
  <VDialog :open="deleteShortcutMode" headline="Are you sure?" modal @close="() => { deleteShortcutMode = false; dummyShortcut = JSON.parse(JSON.stringify(newShortcut)); }">
    <template #body>
    <p class="vtext-body">{{ dummyShortcut.name }} will be removed from the list of shortcuts.</p>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => { dummyShortcut = JSON.parse(JSON.stringify(newShortcut)); deleteShortcutMode = false; }"></VButton>
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="confirmDeleteShortcut()"></VButton>
    </template>
  </VDialog>
</master-layout>
</template>
  
<script>
import apiInterceptor from '@/shared/apiInterceptor';
import ActionPopOver from "@/components/ActionPopOver.vue";
import { queryClient } from '@/shared/queryClient';
import { livechatShortcutsQueryOptions } from '@/composables/useLivechatShortcuts';
import { useUIStore } from '@/stores/ui';
import { environment } from '@/shared/env';
import SearchBar from '@/components/SearchBar.vue';
import moment from 'moment-timezone';


const newTiming = {
  validdays: [],
  validfrom: undefined,
  validtill: undefined,
  is24Hr: false
}
const newShortcut = {
  name: undefined,
  response: undefined
}

export default {
  components: { ActionPopOver, SearchBar },
  data() {
    return {
      close: 'close-line',
      trashOutline: 'delete-line',
      searchOutline: 'search-line',
      arrowForwardOutline: 'arrow-right-line',
      createOutline: 'edit-line',
      informationCircleOutline: 'info-line',
      arrowBackOutline: 'arrow-left-line',
      allTimings: [],
      dataLoaded: false,
      awayMessage: undefined,
      agentMessage: undefined,
      talkToSupportMessage: undefined,
      shortcutFilter: undefined,
      allShortcuts: [],
      allComments: [],
      busyOffice: false,
      busyAway: false,
      busyShortcut: false,
      busyAgent: false,
      busySupport: false,
      deleteTimingMode: false,
      dummyTiming: JSON.parse(JSON.stringify(newTiming)),
      newTiming: JSON.parse(JSON.stringify(newTiming)),
      newShortcut: JSON.parse(JSON.stringify(newShortcut)),
      dummyShortcut: JSON.parse(JSON.stringify(newShortcut)),
      editShortcutModal: false,
      deleteShortcutMode: false,
      activeTab: 'office-hours',
      broadcastIndexToDelete: -1,
      broadcastIndexToEdit: -1,
      daysArr: [ { day: 'Sun', value: '7' }, { day: 'Mon', value: '1' }, { day: 'Tue', value: '2' }, { day: 'Wed', value: '3' }, { day: 'Thr', value: '4' }, { day: 'Fri', value: '5' }, { day: 'Sat', value: '6' } ],
      editMode: false,
      officeHoursIndexToEdit: -1,
      officeHours: {
        validfrom: undefined,
        validtill: undefined,
        validdays: [],
        days: [],
        name: undefined
      },
    }
  },
  mounted(){
    this.initView();
  },
  watch: {
    'officeHours.is24Hrs'(newValue) {
      if (newValue) {
        // Set start time to 00:00 and end time to 23:59 when 24-hour mode is enabled
        this.officeHours.validfrom = "00:00";
        this.officeHours.validtill = "23:59";
      }
    },
  },
  computed: {
    shortcutsToShow() {
      return this.shortcutFilter && this.shortcutFilter.length ? this.allShortcuts.filter((e) => e.name.match(new RegExp(this.shortcutFilter, "gi")) ): this.allShortcuts;
    },
    formattedStartTime() {
      return this.officeHours.is24Hrs ? "00:00" : this.officeHours.validfrom;
    },
    formattedEndTime() {
      return this.officeHours.is24Hrs ? "23:59" : this.officeHours.validtill;
    },
    pageTitle() {
      return this.dummyShortcut.id ? 'Update Shortcut' : 'Add Shortcut';
    },
    disableOfficeBttn() {
      return this.busyOffice || !this.officeHours.validdays?.length || !this.officeHours.validfrom || !this.officeHours.validtill || !this.officeHours.name;
    }
  },
  methods: {
    async initView() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Loading live chat settings...' });
        const [timingsResponse, awayResponse, agentResponse, shortcutsResponse, commentsResponse] = await Promise.allSettled([
          apiInterceptor.get(environment('VUE_APP_API_URL') + "livechat/v1/settings/working_hours"),
          apiInterceptor.get(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/away"),
          apiInterceptor.get(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/intro"),
          queryClient.fetchQuery({ ...livechatShortcutsQueryOptions, staleTime: 0 }),
          apiInterceptor.get(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/talk_to_agent")
        ]);

        if (timingsResponse.status === 'fulfilled') {
          this.allTimings = timingsResponse.value;
          this.allTimings = this.allTimings.map(e => {
            e.validfrom === '00:00' && e.validtill === '23:59' ? e.is24Hrs = true : e.is24Hrs = false;
            return e;
          });
          this.allTimings = this.allTimings.map(timing => {
            const validdaysAsNumbers = timing.validdays.map(day => parseInt(day)); // Convert validdays to numbers
            timing.allDaysEnabled = [1, 2, 3, 4, 5, 6, 7].every(day => validdaysAsNumbers.includes(day));
            return timing;
          });
        } else {
          useUIStore().updateToast({ open: true, message: 'Failed to load timings', type: 'danger' });
        }

        if (awayResponse.status === 'fulfilled') {
          this.awayMessage = awayResponse.value.return_message?.[0];
        } else {
          useUIStore().updateToast({ open: true, message: 'Failed to load away message', type: 'danger' });
        }

        if (agentResponse.status === 'fulfilled') {
          this.agentMessage = agentResponse.value.return_message?.[0];
        } else {
          useUIStore().updateToast({ open: true, message: 'Failed to load agent message', type: 'danger' });
        }

        if (shortcutsResponse.status === 'fulfilled') {
          this.allShortcuts = shortcutsResponse.value.shortcuts;
        } else {
          useUIStore().updateToast({ open: true, message: 'Failed to load shortcuts', type: 'danger' });
        }

        if (commentsResponse.status === 'fulfilled') {
          this.allComments = commentsResponse.value.messages;
          this.talkToSupportMessage = this.allComments.find(e => e.vertex == "20080")?.custom_message;
        } else {
          useUIStore().updateToast({ open: true, message: 'Failed to load comments', type: 'danger' });
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.dataLoaded = true;
      }
    },
    resetOfficeHours() {
      this.officeHours = { validfrom: undefined, validtill: undefined, validdays: [], days: [], name: undefined, is24Hrs: false, allDaysEnabled: false };
    },
    addNewOfficeHours() {
      this.resetOfficeHours();
      this.officeHoursIndexToEdit = -1;
      this.editMode = true;
    },
    editOfficeHours(tIndex) {
      const officeHoursToEdit = this.allTimings[tIndex];
      if (!officeHoursToEdit) return;
      this.officeHours = JSON.parse(JSON.stringify(officeHoursToEdit));
      this.officeHoursIndexToEdit = tIndex;
      this.editMode = true;
    },
    cancelOfficeHoursEdit() {
      this.resetOfficeHours();
      this.officeHoursIndexToEdit = -1;
      this.editMode = false;
    },
    on24HrsToggle(e) {
      this.officeHours.is24Hrs = e.target.checked;
      if (this.officeHours.is24Hrs) {
        this.officeHours.validfrom = "00:00";
        this.officeHours.validtill = "23:59";
      }
    },
    async confirmRemoveTiming() {
      // capture id before awaiting - didDismiss may reset dummyTiming while the delete request is in flight
      const idToRemove = this.dummyTiming.id;
      try {
        useUIStore().updateLoading({ isLoading: true });
        await apiInterceptor.delete( environment("VUE_APP_API_URL") + "livechat/v1/settings/working_hours/" + idToRemove );
        // avoid splice(-1,1) removing the last item if id ever fails to match
        this.allTimings = this.allTimings.filter(e => e.id != idToRemove);
        useUIStore().updateToast({
          open: true,
          message: "Timing deleted successfully!",
          type: "success"
        })
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.dummyTiming = JSON.parse(JSON.stringify(newTiming));
        this.deleteTimingMode = false;
      }
    },
    async saveTimings() {
      try {
        useUIStore().updateLoading({ isLoading: true });
        this.busyOffice = true;
        if (!this.officeHours.validfrom || !this.officeHours.validtill) {
          return useUIStore().updateToast({ open: true, message: "Please choose Start and End time", type: "warning" });
        }
        if (!this.officeHours.validdays?.length) {
          return useUIStore().updateToast({ open: true, message: "Please select at least one day", type: "warning" });
        }

        const finalliveChatTimings = {
          validfrom: this.officeHours.validfrom,
          validtill: this.officeHours.validtill,
          validdays: this.officeHours.validdays.join(","),
          name: this.officeHours.name,
        };
        const apiUrl = environment("VUE_APP_API_URL") + "livechat/v1/settings/working_hours";
        let toastMessage = "Timings added successfully!";
        if (this.officeHoursIndexToEdit !== -1) {
          // Edit existing timings
          await apiInterceptor.patch(`${apiUrl}/${this.allTimings[this.officeHoursIndexToEdit].id}`, {
            ...finalliveChatTimings,
            is_agent: true,
          });
          toastMessage = "Timings updated successfully!";
        } else {
          // Create new timings
          await apiInterceptor.post(apiUrl, { ...finalliveChatTimings, is_agent: true });
        }
        useUIStore().updateToast({ open: true, message: toastMessage, type: "success" });
        await this.initView();
        this.editMode = false;
        this.officeHoursIndexToEdit = -1;
        this.resetOfficeHours();
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || 'Something went wrong', type: "danger" });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.busyOffice = false;
      }
    },
    async updateAwayMessage() {
      try {
        this.busyAway = true;
        if(!this.awayMessage || !this.awayMessage.length) {
          useUIStore().updateToast({
            open: true,
            message: "Away message cannot be empty",
            type: "danger"
          })
          return
        }
        let reqBody = {
          inputmessage: this.awayMessage
        }
        await apiInterceptor.patch( environment("VUE_APP_API_URL") + "livechat/v1/settings/messages/away", reqBody);
        useUIStore().updateToast({
          open: true,
          message: "Away message updated successfully!",
          type: "success"
        })
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.busyAway = false;
      }
    },
    async updateSupportMessage() {
      try {
        this.busySupport = true;
        if(!this.talkToSupportMessage.length) {
          useUIStore().updateToast({
            open: true,
            message: "Support message cannot be empty",
            type: "danger"
          })
          return
        }
        let reqBody = {
          message: this.talkToSupportMessage,
          vertex: 20080
        }
        await apiInterceptor.patch(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/talk_to_agent", reqBody);
        useUIStore().updateToast({
          open: true,
          message: "Support message updated successfully!",
          type: "success"
        })
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.busySupport = false;
      }
    },
    async updateAgentMessage() {
      try {
        this.busyAgent = true;
        let reqBody = {
          inputmessage: this.agentMessage
        }
        await apiInterceptor.patch( environment("VUE_APP_API_URL") + "livechat/v1/settings/messages/intro", reqBody);
        useUIStore().updateToast({
          open: true,
          message: "Welcome message updated successfully!",
          type: "success"
        })
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.busyAgent = false;
      }
    },
    async updateShortcut() {
      try {
        this.busyShortcut = true;
        let formError = false;
        if(!this.dummyShortcut.name || !this.dummyShortcut.name.length) formError = true;
        if(!this.dummyShortcut.response || !this.dummyShortcut.response.length) formError = true;
        if(formError) {
          useUIStore().updateToast({
            open: true,
            message: "Shortcut or message cannot be empty!",
            type: "danger"
          })
          return
        }
        let reqBody = {
          shortcut_name: this.dummyShortcut.name,
          response: this.dummyShortcut.response,
        }
        let editShortcutResponse = this.dummyShortcut.id ? await apiInterceptor.patch(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/shortcuts/" + this.dummyShortcut.id, reqBody) : await apiInterceptor.post(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/shortcuts", reqBody);
        queryClient.invalidateQueries({ queryKey: ['livechat-shortcuts'] });
        if(this.dummyShortcut.id) {
          this.allShortcuts.splice(this.allShortcuts.findIndex(e => e.id === this.dummyShortcut.id), 1, {id: editShortcutResponse.id, name: editShortcutResponse.name, response: editShortcutResponse.response})
          useUIStore().updateToast({
            open: true,
            message: "Shortcut updated successfully!",
            type: "success"
          })
        } else {
          this.allShortcuts.unshift({id: editShortcutResponse.id, name: editShortcutResponse.name, response: editShortcutResponse.response});
          useUIStore().updateToast({
            open: true,
            message: "Shortcut added successfully!",
            type: "success"
          })
        }
        this.dummyShortcut = JSON.parse(JSON.stringify(newShortcut));
        this.editShortcutModal = false;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.busyShortcut = false;
        this.dummyShortcut = JSON.parse(JSON.stringify(newShortcut));
        this.editShortcutModal = false;
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async confirmDeleteShortcut() {
      const shortcutId = this.dummyShortcut.id;
      try {
        useUIStore().updateLoading({ isLoading: true });
        await apiInterceptor.delete(environment('VUE_APP_API_URL') + "livechat/v1/settings/messages/shortcuts/" + shortcutId);
        queryClient.invalidateQueries({ queryKey: ['livechat-shortcuts'] });
        this.allShortcuts.splice(this.allShortcuts.findIndex(e => e.id === shortcutId), 1);
        useUIStore().updateToast({
          open: true,
          message: "Shortcut deleted successfully!",
          type: "success"
        })
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.dummyShortcut = JSON.parse(JSON.stringify(newShortcut));
        this.deleteShortcutMode = false;
      }
    },
    async changeTab(newTab) {
      this.activeTab = newTab;
    },
    selectAllDays(){
      if(this.officeHours.allDaysEnabled){
        this.officeHours.validdays = this.daysArr.map(day => day.value);
      } else{
        this.officeHours.allDaysEnabled = false;
        this.officeHours.validdays = [];
      }
    },
    getValidDaysRange(validdays) {
      const daysMapping = { "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat", "7": "Sun" };
      const mappedDays = validdays.map(day => daysMapping[day]);
      return mappedDays.join(', '); 
    },
    formatTime(time) {
      return moment(time, 'HH:mm').format('hh:mm A');
    },
  }
}
</script>

<style lang="scss" scoped src="../../resources/css/settings.scss"> </style>

<style scoped>

.tabs-toolbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}

.tabs-row {
  display: flex;
  width: 100%;
}

.tab-item {
  flex: 1;
  padding: 14px 10px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  font-family: inherit;
  transition: border-color 0.2s, color 0.2s;
}

.tab-item:hover {
  color: var(--purple);
}

.tab-item.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
  font-weight: 500;
}
.chat-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}

.toolbar-start {
  display: flex;
  align-items: center;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}

.office-row {
  display: grid;
  grid-template-columns: 3fr 7fr 2fr;
  align-items: center;
  padding: 15px 20px;
}

.table-header {
  margin: 0px;
  border-bottom: 1px solid var(--background-primary);
}

.hide-mobile { display: block; }
.show-mobile { display: none; }

.shortcut-table-header {
  border-bottom: 1px solid var(--background-primary);
  padding: 15px 20px;
}

.shortcut-row {
  display: grid;
  grid-template-columns: 4fr 6fr 2fr;
  align-items: center;
  padding: 15px 20px;
}

.shortcut-row.cust-brdr:last-child {
  border-bottom: none;
}

.search-input-shortcuts {
  max-width: 300px;
}

.shortcut-name-input {
  border-radius: 0 5px 5px 0;
}

@media only screen and (max-width: 760px) {
  .hide-mobile { display: none !important; }
  .show-mobile { display: block !important; }
  .office-row {
    grid-template-columns: 1fr 1fr;
  }
  .shortcut-row {
    grid-template-columns: 1fr 1fr;
  }
  .search-input-shortcuts {
    max-width: 100%;
  }
}
</style>
